import { Alert, Link } from "@mui/material";

const REPORTS_DASHBOARD_URL = "https://reports.simpl.org/";

export const ReportsDeprecationBanner = () => (
  <Alert severity="warning" sx={{ mb: 1 }}>
    This page will be deprecated over the coming months. All reporting data is
    now centralized at{" "}
    <Link
      href={REPORTS_DASHBOARD_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      {REPORTS_DASHBOARD_URL}
    </Link>
  </Alert>
);
